import { useState, useEffect, memo, useCallback, useContext } from 'react'

import Price from '../../atoms/price';
import CoinName from '../../atoms/coinName';

import ThemeContext from '../../../context/theme';

// vholc
export interface Coin {
  name: string
  open: number
  close: number
  volume: number
}

interface Props {
  coin: Coin
  key: string
  onClick: Function
}

// const BLUE_DOWN  = '#0051c7';    // 하락
// const RED_UP     = '#A22027';    // 상승
// const BLACK_KEEP = '#505051'     // 유지

const Row = (props: Props) => {
  const theme = useContext(ThemeContext);

  const [colorStatus, setColorStatus] = useState<number>(0);
  const [border, setBorder] = useState<number>(0);      // 이전 거래와 비교로 색상표기
  const [price, setPrice] = useState(props.coin.close); // 전일대비(바로 이전틱)로 색상표기
  
  const rate = (props.coin.close - props.coin.open)/props.coin.open * 100
  
  useEffect(() => {
    if (props.coin.close < price) {
      setBorder(-1)
    } else if (props.coin.close === price) {
      setBorder(0)
    } else {
      setBorder(1)
    }

    if (rate === 0) {
      setColorStatus(0)
    } else if(rate > 0) {
      setColorStatus(-1)
    } else {
      setColorStatus(1)
    }
    
    setPrice(props.coin.close)
  }, [props.coin.close])

  useEffect(() => {
    if (colorStatus !== -2) {
      setTimeout(() => {
        setBorder(-2)
      }, 1000)
    }
  })

  const getColor = () => {
    return colorStatus === 0
      ? theme.change.keep
      : colorStatus === -1
        ? theme.change.down
        : colorStatus === 1
          ? theme.change.up
          : theme.change.keep
  }
  
  const getBoarder = () => {
    return border === 0
      ? theme.change.keep
      : border === -1
        ? theme.change.down
        : border === 1
          ? theme.change.up
          : theme.background.default
  }

  const onClickHandler: any = useCallback(
    (coin: string) => props.onClick(props.coin.name)
    ,[props.coin.name]
  )

  if (!props.coin) return <></>

  return (
    <tr
      key={props.key}
      style={{
        display:"table",
        tableLayout: "fixed",
        width: "100%"
      }}
      onClick={onClickHandler}
    >
      <td style={{
        fontSize: 13,
        borderBottom: `1px solid ${theme.borderColor.default}`,
        borderTop: `1px solid ${theme.borderColor.default}`,
        fontWeight: 900,
        textAlign: "center",
        padding: 3,
        width: "25%",
        color: theme.color.default
      }}>
        <CoinName value={props.coin.name} />
      </td>
      <td style={{ fontSize: 13, color: getColor(), borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%" }}>
        <div style={{ lineHeight: 1.5, boxSizing: "border-box", border: `1px solid ${getBoarder()}`, padding: 10, width: '100%', height: "100%" }}>
          <Price value={props.coin.close} timestamp={new Date().getTime()} />
        </div>
      </td>
      <td style={{fontSize: 13, color: getColor(), borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%"}}>
        <p style={{margin: 0, fontSize: 11}}>
          <Price value={props.coin.open - props.coin.close} timestamp={new Date().getTime()} />
        </p>
        <p style={{margin: 0, fontSize: 9}}>
          <Price value={(props.coin.open - props.coin.close)/props.coin.open * 100} suffix={"%"} timestamp={new Date().getTime()} />
        </p>
      </td>
      <td style={{ fontSize: 13,color: theme.color.default, borderBottom: `1px solid ${theme.borderColor.default}`, borderTop: `1px solid ${theme.borderColor.default}`, textAlign: "right", padding: 3, width: "25%" }}>{props.coin.volume.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{'\u00A0'}{'\u00A0'}</td>
    </tr>
  );
};

export default memo(Row);